var RemovedLeaguesModifier = /** @class */ (function () {
    function RemovedLeaguesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    RemovedLeaguesModifier.prototype.modify = function (content) {
        if (content.leagues === undefined) {
            return;
        }
        var leagues = content.leagues.remove;
        if (leagues !== undefined) {
            for (var i = 0; i < leagues.length; i++) {
                leagues[i] = this._modelKeyRepository.removeLeague(leagues[i]);
            }
        }
    };
    return RemovedLeaguesModifier;
}());
export default RemovedLeaguesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/RemovedLeaguesModifier.js